<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sxWpUo/media/FC-9781638295129.jpg?1684514353530" alt="This image is the cover for the book Christmas Ties"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Christmas Ties
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:19px;font-family:"Grotesque Light",sans-serif;color:black;background:white;'>It was the twelfth day before Christmas. And after St. Nick’s Executive Administrators (Jeff, Dimitrius, and Su) shared with him two disturbing “Dear Santa” letters from New York City – Gabby and Gabe, twelve-year old twins – it broke his heart. So, St. Nick made the critical decision to take time out of his busy schedule and fly to the Big Apple. With Mrs. Nick by his side, they take a jet plane from the North Pole instead of the reindeer driven sleigh to find out what is troubling the kids.</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Margie Woods
      </h2>
      
      <p class="authorDescription body article"><p style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Calibri",sans-serif;'><br></p><p style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Calibri",sans-serif;text-align:justify;'><span style='font-size:15px;font-family:"Times New Roman",serif;'>Margie Woods, a Texas native, is an innovative author with stories as deep as the heart of this great state. The inspiration of the many novels she writes comes from a world within her mind&rsquo;s eye, which is most definitely thought-provoking, stimulating, passionate, and gives a creative beauty and bloom to the unconventional. She is an artist who gives living color to fiction, non-fiction, lyrics, and poems.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9f1478f6